import React from 'react';
import { Box, Typography, Stack, Link, Chip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const ContentList = ({
    contents,
    onUserClick,
    shouldEdit,
    shouldDelete,
    onDeleteClick,
}) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {contents.map((content, index) => (
                <Box
                    key={content.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== contents.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: '400',
                            color: '#292929',
                        }}
                    >
                        {content.title}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#292929',
                        }}
                    >
                        {content.description}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#292929',
                            mt: 2,
                        }}
                    >
                        Jogos
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        {content.games.slice(0, 3).map((game) => (
                            <Chip
                                key={game.id}
                                label={game.name}
                                size="small"
                                color="primary"
                            />
                        ))}
                        {content.games.length > 3 && (
                            <Chip
                                label={`+${content.games.length - 3}`}
                                size="small"
                                color="default"
                            />
                        )}
                    </Stack>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#292929',
                            mt: 2,
                        }}
                    >
                        Jogos
                    </Typography>

                    <Stack direction="column" spacing={1} sx={{ mt: 1 }}>
                        {content.groups.slice(0, 3).map((group) => (
                            <Chip
                                key={group.id}
                                label={group.name}
                                size="small"
                                color="primary"
                                sx={{
                                    maxWidth: '120px',
                                }}
                            />
                        ))}
                        {content.groups.length > 3 && (
                            <Chip
                                label={`+${content.groups.length - 3}`}
                                size="small"
                                color="default"
                            />
                        )}
                    </Stack>

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: 2, justifyContent: 'start' }}
                    >
                        {shouldEdit && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onUserClick(content);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <EditOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>Editar</Typography>
                            </Link>
                        )}
                        {shouldDelete && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onDeleteClick(content);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <DeleteOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>
                                    Excluir
                                </Typography>
                            </Link>
                        )}
                    </Stack>
                </Box>
            ))}
        </Box>
    );
};

export default ContentList;
